"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileExtension = exports.formatBytes = void 0;

var formatBytes = function formatBytes(bytes) {
  if (bytes === 0) return "0B";
  var k = 1024;
  var sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + sizes[i];
}; // https://stackoverflow.com/questions/680929/how-to-extract-extension-from-filename-string-in-javascript


exports.formatBytes = formatBytes;

var getFileExtension = function getFileExtension(value) {
  return /(?:\.([^.]+))?$/.exec(value)[1];
};

exports.getFileExtension = getFileExtension;